import { Component, Input } from '@angular/core';
import { StepSection } from './models/step-section.interfaces';

@Component({
  selector: 'idp-step-section',
  templateUrl: './step-section.component.html',
  styleUrls: ['./step-section.component.scss']
})
export class StepSectionComponent {
  @Input() content: StepSection;
  @Input() secondary = false;
  @Input() ariaHiddenValue = '';
  @Input() ariaLabelledValue = '';

  constructor() {
    this.content = this.initDefaultValues();
  }

  initDefaultValues(): StepSection {
    return {
      step: '',
      title: '',
      subtitle: '',
      description: ''
    };
  }
}
